module.exports = __webpack_public_path__ + "qr-code.png?c74aab4b7e9a492ef1c74e313f23a2fc";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/point-register/qr-code.png
// module id = 996
// module chunks = 0